// type 0-send, 1-received
export class UserChat {
  static chat = [
    {
      friend_id: 1,
      friend_photo: 'assets/images/avatar-3.jpg',
      messages: [
        {
          type: 1,
          msg: "I'm just looking around. Will you tell me something about yourself?",
          time: '8:20 a.m',
        },
        {
          type: 0,
          msg: 'Ohh! very nice',
          time: '8:22 a.m',
        },
        {
          type: 1,
          msg: 'can you come with me?',
          time: '8:22 a.m',
        },
      ],
    },
    {
      friend_id: 2,
      friend_photo: 'assets/images/avatar-2.jpg',
      messages: [
        {
          type: 1,
          msg: 'Hiii!!! Good Morning',
          time: '6:48 a.m',
        },
        {
          type: 0,
          msg: 'Hello, Very Good Morning',
          time: '6:50 a.m',
        },
        {
          type: 0,
          msg: 'How are You?',
          time: '8:50 a.m',
        },
        {
          type: 1,
          msg: 'Fine, What do you do?',
          time: '8:51 a.m',
        },
      ],
    },
    {
      friend_id: 3,
      friend_photo: 'assets/images/avatar-4.jpg',
      messages: [
        {
          type: 1,
          msg: "I'm just looking around. Will you tell me something about yourself?",
          time: '8:20 a.m',
        },
        {
          type: 0,
          msg: 'Ohh! very nice',
          time: '8:22 a.m',
        },
        {
          type: 1,
          msg: 'can you come with me?',
          time: '8:22 a.m',
        },
      ],
    },
    {
      friend_id: 4,
      friend_photo: 'assets/images/avatar-3.jpg',
      messages: [
        {
          type: 1,
          msg: 'Hiii!!! Good Morning',
          time: '6:48 a.m',
        },
        {
          type: 0,
          msg: 'Hello, Very Good Morning',
          time: '6:50 a.m',
        },
        {
          type: 0,
          msg: 'How are You?',
          time: '8:50 a.m',
        },
        {
          type: 1,
          msg: 'Fine, What do you do?',
          time: '8:51 a.m',
        },
      ],
    },
    {
      friend_id: 5,
      friend_photo: 'assets/images/avatar-2.jpg',
      messages: [
        {
          type: 1,
          msg: "I'm just looking around. Will you tell me something about yourself?",
          time: '8:20 a.m',
        },
        {
          type: 0,
          msg: 'Ohh! very nice',
          time: '8:22 a.m',
        },
        {
          type: 1,
          msg: 'can you come with me?',
          time: '8:22 a.m',
        },
      ],
    },
  ];
}
